import { format } from 'date-fns';
import { undefinedCheck } from './undefinedCheck';

export function formatToCurrency(number?: number) {
	return new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(number ?? 0);
}

export function formatToThousands(number?: number) {
	if (!number) return '0';

	return new Intl.NumberFormat('en-GB', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	}).format(number);
}

export function formatToCurrencyOrDefault(number: number | undefined) {
	if (!number) return '£0.00';

	return new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(number);
}

export function formatToDateString(date: Date) {
	return format(date, 'dd MMMM yyyy');
}

export function formatToDateStringOrDefault(date?: Date) {
	if (date === undefined) return undefinedCheck(undefined);

	return format(date, 'dd MMMM yyyy');
}

export function formatToShortDateString(date: Date) {
	return format(date, 'dd/MM/yyyy');
}

export function formatToShortDateStringOrDefault(date?: Date) {
	if (date === undefined) return undefinedCheck(undefined);

	return format(date, 'dd/MM/yyyy');
}

export function formatToTimeString(date: Date) {
	return format(date, 'HH:mm:ss');
}

export function formatToTimeStringOrDefault(date?: Date) {
	if (date === undefined) return undefinedCheck(undefined);

	return format(date, 'HH:mm:ss');
}

export function formatToMonthYear(date: Date) {
	return format(date, 'MMMM yyyy');
}

export function formatToPercentage(value: number) {
	return new Intl.NumberFormat('en-GB', {
		style: 'percent',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(value);
}

export function formatToDecimal(value: number) {
	return new Intl.NumberFormat('en-GB', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(value);
}

export function formatTillId(name: string, id: string, branchId: string) {
	return `Name-${name}&Id-${id}&BranchId-${branchId}&`;
}

export function formatSecondsToHours(totalSeconds: number): string {
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;

	return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
